import styled from 'styled-components';
import { styles } from '../../styles';

export const ListError = styled.div`
    color: #F8001F;
    font-family: ${styles.defaultFont};
    font-size: 14px;
`;